import { defineStore } from 'pinia'

export interface MovementState {
  positionX: number
  positionY: number
}

const initialState = (): MovementState => ({
  positionX: 0,
  positionY: 0
})

export const movementState = defineStore('movementState', {
  state: initialState,
})
